import { render, staticRenderFns } from "./addReturnCredent.vue?vue&type=template&id=b184cc18&"
import script from "./addReturnCredent.vue?vue&type=script&lang=js&"
export * from "./addReturnCredent.vue?vue&type=script&lang=js&"
import style0 from "./addReturnCredent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b184cc18')) {
      api.createRecord('b184cc18', component.options)
    } else {
      api.reload('b184cc18', component.options)
    }
    module.hot.accept("./addReturnCredent.vue?vue&type=template&id=b184cc18&", function () {
      api.rerender('b184cc18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/backhaul/components/components/addReturnCredent.vue"
export default component.exports